module.exports = __webpack_public_path__ + "img/survival.df9c3703.jpg";